export function allCapturedTrims(floor) {
    return [...(floor.areas ?? []).flatMap(a => a.trims ?? []), ...(floor.trimRuns ?? [])];
}
export function effectiveTrimLengthMM(trim, floor) {
    if (trim.measurementSource)
        return trim.segments?.length ? trim.segments.reduce((n, s) => n + s.lengthMM, 0) : Number(trim.lengthMM ?? 0);
    const id = trim.anchor?.doorway?._0;
    const door = id ? [...(floor.areas ?? []).flatMap(a => a.doorways ?? []), ...(floor.wallDoors ?? [])].find(d => d.id === id) : undefined;
    return Number(door?.widthMM ?? trim.lengthMM ?? 0);
}
export function trimCaptureValid(trim) {
    if (trim.segments != null && (!Array.isArray(trim.segments) || !trim.segments.every(s => s && typeof s.name === 'string' && typeof s.lengthMM === 'number')))
        return false;
    const mm = effectiveTrimLengthMM(trim, {});
    return Number.isFinite(mm) && mm > 0 && mm <= 10000000 && typeof trim.location === 'string' && !!trim.location.trim() && typeof trim.purpose === 'string' && ['doorway', 'wardrobe', 'entry', 'cupboard', 'glass', 'expansion', 'other'].includes(trim.purpose)
        && (trim.purpose !== 'other' || (typeof trim.installationNote === 'string' && !!trim.installationNote.trim()))
        && (!trim.segments?.length || trim.segments.every(s => s.name.trim() && Number.isFinite(s.lengthMM) && s.lengthMM > 0));
}
//# sourceMappingURL=trim-capture.js.map